export default "__VITE_ASSET__CDjHb9_W__"